<template>
  <div class="bgwhite role">
    <!-- 角色管理 -->
    <div class="flex_between bbe9s">
      <div class="title f-left p10">角色管理</div>
    </div>
    <!-- 添加管理员 -->
    <el-button class="mt30 ml10" type="primary" size="small" plain @click="addmanager">添加管理员</el-button>
    <!-- 编辑话术 -->
    <!-- <el-button class="mt30 ml20" type="success" size="small" plain @click="huashuedit">编辑话术</el-button> -->
    <!-- 内容 -->
    <div class="mt20">
      <el-table :data="tableData" border>
        <el-table-column prop="admin_id" label="序号" align="center" width="50"></el-table-column>
        <el-table-column prop="username" label="名称" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机" align="center"></el-table-column>
        <el-table-column label="权限" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.administrators==0">客服</span>
            <span v-else>管理员</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="success" size="small" plain
              @click.native="editper(scope.row.admin_id)"
              class="btn"
            >编辑<i class="el-icon-edit"></i></el-button>
            <el-button type="danger" size="small" plain  @click.native="del(scope.row.admin_id)" class="btn">删除<i class="el-icon-delete"></i></el-button>
            <el-button type="info" size="small" plain  @click.native="cang(scope.row.admin_id)" class="btn">隐藏<i class="el-icon-switch-button"></i></el-button>
            <el-button type="primary" size="small" plain  @click.native="cha(scope.row.admin_id)" class="btn">查看<i class="el-icon-view"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹框 -->
    <el-dialog :title="tantitle" :visible.sync="dialogFormVisible" center>
      <div v-if="diagname=='bian'" style="padding-left:26%;">
        <el-form :model="form">
          <el-form-item label="名称" :label-width="formLabelWidth" style="color:#606266">
            <el-input v-model="form.name" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item label="手机" :label-width="formLabelWidth">
            <el-input v-model="form.phone" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item v-if="kind=='add'" label="密码" :label-width="formLabelWidth">
            <el-input type="password" v-model="form.password" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item label="分配" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择角色分配" style="width:240px;">
              <el-option label="管理员" value="管理员"></el-option>
              <el-option label="一般客服" value="一般客服"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外呼编号" :label-width="formLabelWidth">
            <el-input type="text" v-model="form.wnumber" autocomplete="off" style="width:240px;"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="kind=='add'" class="mr20" type="primary" plain size="small" @click="addtijiao()" style="margin-left: 35%;">提 交</el-button>
          <el-button v-if="kind!='add'" class="mr20" type="primary" plain size="small" @click="addtijiao()" style="margin-left: 30%;">提 交</el-button>
          <el-button v-if="kind!='add'" type="danger" plain size="small" @click="chongzhi()">重置密码</el-button>
        </div>
      </div>
      <!-- 查看 -->
      <div v-if="diagname=='cha'">
        <el-table :data="tableData2" ref="multipleTable2" border v-loading="loading">
          <el-table-column prop="order_no" label="订单号"></el-table-column>
          <el-table-column label="任务类型">
           <template slot-scope="scope">
             <span v-if="scope.row.type == 0">指派任务</span>
          <span v-if="scope.row.type == 1">超时未接单</span>
          <span v-if="scope.row.type == 2">打卡未报价</span>
          <span v-if="scope.row.type == 3">施工超期</span>
          <span v-if="scope.row.type == 4">完工回访</span>
          <span v-if="scope.row.type == 5">差评与投诉</span>
             <!-- <span v-if="scope.row.type == 2"
                  >上门跟进任务</span
                >
                <span v-if="scope.row.type == 3"
                  >签约跟进任务</span
                >
                <span v-if="scope.row.type == 4"
                  >施工跟进任务</span
                >
                <span v-if="scope.row.type == 8"
                  >取消挽回任务</span
                >
                <span v-if="scope.row.type == 9"
                  >退单挽回任务</span
                >
                <span v-if="scope.row.type == 7"
                  >完工回访任务</span
                >
                <span
                  v-if="
                    (scope.row.type == 20 || scope.row.type == 0)"
                  >订单指派任务</span
                >
                <span v-if="scope.row.type == 10"
                  >订单投诉任务</span
                > -->
          </template>
          </el-table-column>
          <el-table-column prop="contacts" label="联系人"></el-table-column>
          <el-table-column prop="telephone" label="联系方式"></el-table-column>
          <el-table-column prop="addres" label="维修地址"></el-table-column>
          <el-table-column prop="states" label="订单状态"></el-table-column>
          <el-table-column prop="store_name" label="店铺"></el-table-column>
        </el-table>
        <div class="flex_start mt20 flex_items">
          <span class="demonstration mr20">
            总共
            <span style="color:red">{{count}}</span>条数据,当前
            <span style="color:red">{{tableData2.length}}</span>条
          </span>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 话术编辑 -->
    <el-dialog title="话术编辑" :visible.sync="huashukuang" center>
      <div v-loading="loadinghua" style="padding-left:10%;">
        <div v-for="(item,index) in huashus" :key="index" class="flex_start flex_items mt20">
          <span v-if="item.type==1" style="width:160px">签约跟进任务</span>
          <span v-if="item.type==2" style="width:160px">待上门跟进任务</span>
          <span v-if="item.type==3" style="width:160px">施工中跟进任务</span>
          <span v-if="item.type==4" style="width:160px">完工回访任务</span>
          <textarea style="width:70%;height:60px;outline:none" class="p5" v-model="item.content"></textarea>
        </div>
      </div>
      <div>
        <el-button
          class="mr20"
          type="primary"
          size="small"
          plain
          @click="huashutijiao"
          style="margin: 30px auto;display:flex"
        >提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      dialogFormVisible: false,
      huashukuang: false,
      loadinghua: true,
      kind: "add",
      tantitle: "添加角色",
      whobian: "",
      form: {
        name: "",
        phone: "",
        region: "",
        password: "",
        wnumber: ""
      },
      formLabelWidth: "120px",
      diagname: "bian",
      // 分页数据
      currentPage3: 1,
      tableData2: [],
      count: 0,
      loading: true,
      huashus: []
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    // 列表
    getLists(aa) {
      this.$loading(this.util.opload);
      this.util.get(this.HOST + "/User/user", {}).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.$loading().close();
        }else{
          this.$loading().close();
          this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
        }
      });
    },
    addmanager() {
      this.diagname = 'bian'
      this.kind = "add";
      this.tantitle = "添加角色";
      this.form.name = "";
      this.form.phone = "";
      this.form.region = "";
      this.form.password = "";
      this.form.wnumber = "";
      this.dialogFormVisible = true;
    },
    // 隐藏
    cang(admin) {
      this.util
        .post(this.HOST + "/User/hider", {
          admin_id: admin
        })
        .then(res => {
          if (res.code == 200) {
            // this.tableData = res.data;
            this.getLists();
            // this.$loading().close();
          }else{
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 添加
    addtijiao() {
      let telStr = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;
      if (this.form.name == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请输入名称!",
          duration: 1200,
          offset:90
        });
        return false;
      }
      if (!telStr.test(this.form.phone)) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请输入正确手机号!",
          duration: 1200,
          offset:90
        });
        return false;
      }
      if (this.form.password == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请输入密码!",
          duration: 1200,
          offset:90
        });
        return false;
      }
      if (this.form.region == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请选择分配角色!",
          duration: 1200,
          offset:90
        });
        return false;
      }
      if (this.form.wnumber == "") {
        this.$message({
          showClose: true,
          type: "error",
          message: "请输入外呼编号!",
          duration: 1200,
          offset:90
        });
        return false;
      }
      // if (this.form.password == "") {
      //   this.$message({
        // showClose: true,
      //     type: "error",
      //     message: "请输入默认密码!"
      //   });
      //   return false;
      // }
      let text = "正在添加";
      let url = "/User/add";
      let admin_id = "";
      if (this.kind == "edit") {
        this.form.password = "";
        text = "提交编辑中...";
        url = "/User/up";
        admin_id = this.whobian;
      }
      this.$loading({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.7)",
        text: text
      });
      let region2 = 0;
      if (this.form.region == "管理员") {
        region2 = 1;
      }
      this.util
        .get(this.HOST + url, {
          username: this.form.name,
          mobile: this.form.phone,
          administrators: region2,
          type: 1,
          new_password: this.form.password,
          logo: "",
          admin_id: admin_id,
          gh: this.form.wnumber
        })
        .then(res => {
          if (res.code == 200) {
            sessionStorage.setItem("integratedid", this.form.wnumber);
            this.$loading().close();
            this.$message({
              showClose: true,
              message: "处理成功!",
              type: "success",
              duration: 1200,
              offset:90
            });
            setTimeout(() => {
              this.dialogFormVisible = false;
              this.tableData = [];
              this.getLists();
            }, 1000);
          }else{
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 编辑话术
    huashuedit() {
      this.huashukuang = true;
      this.util.get(this.HOST + "/User/read ", {}).then(res => {
        if (res.code == 200) {
          this.huashus = res.data;
          this.loadinghua = false;
        }else{
          this.loadinghua = false;
          this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
        }
      });
    },
    huashutijiao() {
      let arr = [];
      arr = this.huashus;
      this.util
        .get(this.HOST + "/User/write", {
          arr
        })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "编辑成功",
              type: "success",
              duration: 1200,
              offset:90
            });
            setTimeout(() => {
              this.huashukuang = false;
            }, 1000);
          }else{
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
            setTimeout(() => {
              this.huashukuang = false;
            }, 1000);
          }
        });
    },
    // 打开编辑
    editper(idx) {
      this.kind = "edit";
      this.tantitle = "编辑角色";
      this.diagname = "bian";
      this.whobian = idx;
      this.util
        .get(this.HOST + "/User/up", {
          admin_id: idx,
          type: 2
        })
        .then(res => {
          if (res.code == 200) {
            this.dialogFormVisible = true;
            this.form.name = res.data.username;
            // this.form.password = res.data.password;
            this.form.phone = res.data.mobile;
            this.form.wnumber = res.data.gh;
            if (res.data.administrators == 0) {
              this.form.region = "一般客服";
            } else {
              this.form.region = "管理员";
            }
          }else{
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 重置
    chongzhi(idx) {
      this.$loading({
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.7)",
        text: "重置中..."
      });
      this.util
        .post(this.HOST + "/Login/Password", {
          admin_id: this.whobian
        })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
              duration: 1200,
              offset:90
            });
            setTimeout(() => {
              this.dialogFormVisible = false;
              this.$loading().close();
            }, 1000);
          }else{
            this.$loading().close();
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 删除
    del(idx) {
      this.$confirm("确认删除此角色吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.okdel(idx);
        })
        .catch(() => {});
    },
    okdel(idx) {
      this.util
        .get(this.HOST + "/User/del", {
          admin_id: idx
        })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "删除成功!",
              type: "success",
              duration: 1200,
              offset:90
            });
            setTimeout(() => {
              this.dialogFormVisible = false;
              this.tableData = [];
              this.getLists();
            }, 1000);
          }else{
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 查看
    cha(idx) {
      this.diagname = "cha";
      this.tantitle = "查看任务";
      this.dialogFormVisible = true;
      this.getall(idx);
    },
    getall(idx) {
      this.util
        .get(this.HOST + "/User/ccList", {
          page: this.currentPage3,
          complaints: "",
          admin_id: idx,
          city_id: "",
          type: 8,
          limit: 10,
          types: 0,
          SelectedStatus: 2
        })
        .then(res => {
          if (res.code == 200) {
            this.count = res.data.count;
            this.tableData2 = res.data.data;
            this.loading = false;
          }else{
            this.loading = false;
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
              duration: 1200,
              offset:90
            });
          }
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.loading = true;
      this.getall();
    }
  }
};
</script>
<style scoped>
.role{
  padding-left: 20px;
  color: #606266 !important;
}
 .el-form-item__label {
  color: #606266 !important;
}
.btn {
  margin-top: 5px;
  padding-right: 2px!important;
  padding-left: 15px!important;
}
.el-badge {
  z-index: 80 !important;
}
</style>